import styled from 'styled-components';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import { variableFontRegular } from 'styles/theme/text';

const UNIVERSAL = 'universal';

interface IChoiceLabel {
  option: IFacetOption;
  productType: string;
  selectedGender: string;
  showSizeConversions: boolean;
  userSizePreferenceUnit: string;
}

export const ChoiceLabel = ({
  option,
  productType,
  selectedGender,
  showSizeConversions,
  userSizePreferenceUnit,
}: IChoiceLabel) => {
  const sizingInfoArr = Object.entries(option?.data?.sizing_info);
  const isUniversalSize = sizingInfoArr.length === 1 && sizingInfoArr[0]?.[0] === UNIVERSAL;
  const selectedUnit = sizingInfoArr.find((sizeInfo) => sizeInfo[0] === userSizePreferenceUnit);
  const universalSize = sizingInfoArr.find((sizeInfo) => sizeInfo[0] === UNIVERSAL);
  const userPreferenceSize =
    userSizePreferenceUnit === 'us' && universalSize
      ? universalSize?.[1]?.[productType]?.[selectedGender]
      : selectedUnit?.[1]?.[productType]?.[selectedGender];

  const isSizeNotANum = (size) => {
    return Number.isNaN(Number.parseFloat(size));
  };

  if (isUniversalSize) {
    return <span>{universalSize?.[1]?.[productType]?.[selectedGender]}</span>;
  }

  return (
    <div>
      <ChoiceLabel.SizeLabelUserPreference>
        {isSizeNotANum(userPreferenceSize)
          ? userPreferenceSize
          : Number.parseFloat(userPreferenceSize)}
        {(productType === 'sneakers' || productType === 'shoes') && selectedGender[0]}
      </ChoiceLabel.SizeLabelUserPreference>
      {showSizeConversions && (
        <ChoiceLabel.SizeLabelOption>
          {sizingInfoArr.map(([country, sizeInfo]) => {
            if (country === userSizePreferenceUnit || country === UNIVERSAL) return;
            const size = sizeInfo?.[productType]?.[selectedGender];

            return (
              <ChoiceLabel.SizeLabel key={`${country}_${size}`}>
                <ChoiceLabel.SizeLabelCountry>{country}</ChoiceLabel.SizeLabelCountry>
                <span>{isSizeNotANum(size) ? size : Number.parseFloat(size)}</span>
              </ChoiceLabel.SizeLabel>
            );
          })}
        </ChoiceLabel.SizeLabelOption>
      )}
    </div>
  );
};

ChoiceLabel.SizeLabelOption = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 16px;
  grid-auto-flow: column;
  margin-top: 8px;
`;

ChoiceLabel.SizeLabelUserPreference = styled.div`
  text-transform: uppercase;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;

ChoiceLabel.SizeLabel = styled.div`
  margin-bottom: 4px;
`;

ChoiceLabel.SizeLabelCountry = styled.span`
  text-transform: uppercase;
  margin-right: 2px;
`;
